import { Field } from "formik";

const SelectInput = ({ field, setFieldValue, values }) => {
  return (
    <Field as="select" name={field.name} disabled={field.disabled}  value= {field.value}  onChange={(e)=>{field.onChange(e,setFieldValue)}} className="w-full px-4 py-2 border border-gray-300 rounded-lg">
      {field?.EditMode ? field.options?.map((option, i) => (
        option.value == values[field.name] ? <option value="" selected> {option.label}</option> : ''
      )) : <option value="">Select {field.label}</option>}
      {field.options?.map((option, i) => (
        <option key={i} value={option.value || ""}>{option.label || "No label"}</option>
      ))}
    </Field>
  );
};

export default SelectInput;